import React from "react"
import { classNames } from "../../utils/classNames"
import { CustomImage } from "../general/CustomImage"
import { Link } from "gatsby"

interface HeroSectionTransparenzProps {
  h1: string
  onApplyClick: () => void
  type?: string
  gender?: string
}

export const HeroSectionTransparenz = ({
  h1,
  type,
  gender,
}: HeroSectionTransparenzProps) => {
  return (
    <div className={"bg-gradient-to-r from-red to-lighterRed"}>
      <div className={"max-w-7xl mx-auto flex"}>
        <div className={"mt-10 mb-10 lg:mb-[80px] lg:mt-[150px] px-4 sm:px-6"}>
          <div className={"lg:max-w-[800px] my-auto font-serif prose"}>
            <h3
              className={
                "uppercase text-white font-bold font-sans text-base tracking-widest"
              }
            >
              Vergütungsexperten
            </h3>
            <h1
              className={"text-[46px] text-white font-medium mb-4"}
              dangerouslySetInnerHTML={{ __html: h1 }}
            />
            <div className={"flex flex-col md:flex-row gap-x-16 mb-8"}>
              <div>
                <h4
                  className={
                    "uppercase text-yellow font-bold font-sans text-base tracking-widest"
                  }
                >
                  Beschäftigungsart
                </h4>
                <p
                  className={
                    "text-white text-[18px] font-light leading-[1.54] font-sans"
                  }
                >
                  {type || "Festanstellung"}
                </p>
              </div>
            </div>
            <Link
              className={classNames(
                "hover:font-semibold border text-white p-5 uppercase tracking-wider mt-16 font-sans no-underline"
              )}
              to={"#user-content-mehr"}
            >
              Jetzt anfragen
            </Link>
          </div>
        </div>
        <div className={"items-center flex justify-self-end"}>
          {gender === "female" ? (
            <CustomImage
              src={"/assets/verfuegbare-verguetungsexpertin.svg"}
              alt={"Infos zur EU-Entgelttransparenzrichtlinie"}
              className={"w-[360px] lg:w-[640px] hidden lg:block "}
            />
          ) : (
            <CustomImage
              src={"/assets/verfuegbarer-verguetungsexperte.svg"}
              alt={"Infos zur EU-Entgelttransparenzrichtlinie"}
              className={"w-[360px] lg:w-[640px] hidden lg:block "}
            />
          )}
        </div>
      </div>
    </div>
  )
}
